import * as Yup from 'yup';
import { branchOfficesSchema } from 'v3/components/BranchOfficesSelect';
import { isValid, isBefore, isAfter, parse } from 'date-fns';

function whiteSpace(value) {
  if (value) {
    const onlySpace = value.replace(/\s/g, '');
    return !!onlySpace;
  }
  return true;
}

function validateDate(value) {
  if (value) {
    const date = parse(value, 'yyyy-MM-dd', new Date());

    if (!isValid(date)) {
      return false;
    }

    return isBefore(date, new Date());
  }

  return true;
}

export const registerSchema = Yup.object().shape({
  generalData: Yup.object().shape({
    branchOffices: branchOfficesSchema,
    plate: Yup.string()
      .required('Campo obrigatório')
      .test('white-space-field', 'Campo inválido', value => whiteSpace(value)),
    renavam: Yup.string()
      .required('Campo obrigatório'),
    yearModel: Yup.string()
      .required('Campo obrigatório'),
    yearManufacture: Yup.string()
      .required('Campo obrigatório'),
    crlv: Yup.string()
      .required('Campo obrigatório'),
    color: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    vehicleType: Yup.object()
      .shape({
        id: Yup.number().required(),
      })
      .nullable()
      .required('Tipo de veículo obrigatório'),
    implementType: Yup.object()
      .nullable()
      .required('Tipo de implemento obrigatório')
      .typeError('Tipo de implemento obrigatório'),
    bodyType: Yup.object()
      .when('implementType', {
        is: implementType => implementType?.name === 'Dolly',
        then: schema => schema
          .nullable()
          .optional(),
        otherwise: schema => schema
          .nullable()
          .required('Tipo de carroceria obrigatória'),
      }),
    axis: Yup.string()
      .required('Campo obrigatório'),
    brand: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    model: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    chassi: Yup.string()
      .required('Campo obrigatório')
      .test('white-space-field', 'Campo inválido', value => whiteSpace(value)),
    city: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    totalGrossWeight: Yup.number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório')
      .min(0, 'Valor deve ser maior ou igual a 0'),
    tareMass: Yup.number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório')
      .min(0, 'Valor deve ser maior ou igual a 0'),
    cubage: Yup.number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório')
      .min(0, 'Valor deve ser maior ou igual a 0'),
  }),
  anttData: Yup.object().shape({
    anttType: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    antt: Yup.string()
      .required('Campo obrigatório'),
    anttAdherence: Yup.string()
      .required('Campo obrigatório')
      .typeError('Data inválida')
      .test('invalid-date', 'Data inválida', value => validateDate(value)),
    anttOwner: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
  }),
  ownerData: Yup.object().shape({
    owner: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    beneficiary: Yup.object()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
  })
});

export async function validate(data, setErrors) {
  const errorList = {};
  try {
    await registerSchema.validate(data, {
      abortEarly: false,
    });
    return true;
  } catch (err) {
    const validationErrors = err?.inner?.length ? err.inner : [err];

    validationErrors.forEach(error => {
      if (!error?.path) return;

      const parts = error.path.split('.');
      if (parts.length > 1) {
        const [section, ...rest] = parts;
        if (!errorList[section]) errorList[section] = {};
        errorList[section][rest.join('.')] = error?.message;
      } else {
        errorList[error.path] = error?.message;
      }
    });

    return false;
  } finally {
    setErrors(errorList);
  }
}
